import {
  Message,
  UserMessageContent,
} from "@redotech/redo-model/agents/llm-messages";

export const transformMessageContent = (message: Message): string => {
  const content = (message as any).content;
  if (typeof content === "string") {
    return content;
  }
  if (Array.isArray(content)) {
    return (content as UserMessageContent[])
      .map((part) => (part.type === "text" ? part.text : ""))
      .filter((text) => text.length > 0)
      .join(" ");
  }
  return String(content);
};

export const transformMessagesForBackend = (messages: Message[]) =>
  messages.map((message) => {
    if (message.role === "tool") {
      return message as any;
    }
    return {
      id: message.id,
      role: message.role,
      content: transformMessageContent(message),
      ...(message.role === "assistant"
        ? {
            // These optional fields may exist on assistant messages in this app
            ...((message as any).feedback !== undefined && {
              feedback: (message as any).feedback,
            }),
            ...((message as any).comment !== undefined && {
              comment: (message as any).comment,
            }),
            ...((message as any).usage !== undefined && {
              usage: (message as any).usage,
            }),
          }
        : {}),
    };
  });

export const buildIntercomTranscript = (messages: Message[]): string => {
  return messages
    .filter((m) => m.role !== "tool")
    .map((message) => {
      const content = transformMessageContent(message);
      // Skip messages with empty content (tool calls without responses)
      if (!content || content.trim() === "") {
        return null;
      }
      const role = message.role === "assistant" ? "AI" : "You";
      return `${role}:\n${content}`;
    })
    .filter((entry) => entry !== null)
    .join("\n\n");
};
